import { render, staticRenderFns } from "./Vincular.vue?vue&type=template&id=1ce6aca6&scoped=true"
import script from "./Vincular.vue?vue&type=script&lang=js"
export * from "./Vincular.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=1ce6aca6&prod&scoped=true&lang=css&external"
import style1 from "./Vincular.vue?vue&type=style&index=1&id=1ce6aca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce6aca6",
  null
  
)

export default component.exports